export default __webpack_public_path__ + "static/media/1129.00f5df93.png";